<evc-modal [showCloseButton]="true" [height]="'500px'" [width]="'470px'" (closeModal)="close()" [showReduceButton]="false">
  <div modal-title>
    {{ "supportPage.title" | translate }}
  </div>
  <div modal-content class="content">
    <svg class="QRCode">
      <use xlink:href="assets/icons/QRCode.svg#QRCode" href="assets/icons/QRCode.svg#QRCode" />
    </svg>
    <div class="message">
      <evc-svg-icon icon="arrow-up" size="md" class="arrow"></evc-svg-icon>
      <span>{{ "supportPage.message" | translate }}</span>
    </div>
  </div>
</evc-modal>
